import { FolderCopy, Folder, Group, Map, RuleSharp, Report } from "@mui/icons-material"
import { Box, Divider, Drawer } from "@mui/material"

import { RoutePathNames } from "../../helpers/constants"

interface Props {
    drawerWidth: string
    isSidebarOpen: boolean
    setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

}

function Sidebar(props: Props) {
    const path = window.location.pathname.replace('/', '');

    //const { id } = useParams();
    return (
        <>
            <Box component='nav'>
                {props.isSidebarOpen && (
                    <Drawer
                        open={props.isSidebarOpen}
                        onClose={() => props.setIsSidebarOpen(false)}
                        variant="persistent"
                        anchor="left"
                        sx={{
                            width: props.drawerWidth,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: props.drawerWidth,
                                boxSizing: 'border-box',
                                overflowY: 'hidden'
                            },
                        }}
                    >
                        <div style={{ width: '100%', }} >
                            <img style={{ height: '50px', marginLeft: '23px' }} src='../../assets/images/logo_totalenergies.png' alt="logo.jpeg" />
                        </div>
                        <Divider />
                        <br/>
                        <div className='side-nav-area' style={{ overflowY: 'auto', height: 'calc(100vh - 10px)' }}>
                            <ul>
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.CTBMAPPINGKEYS} className={path === `${RoutePathNames.CTBMAPPINGKEYS}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <Map fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>CTB Mapping Keys</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.CTBRECORDS} className={path === `${RoutePathNames.CTBRECORDS}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <Folder fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>CTB Records</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                 <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.GTBMAPPINGKEYS} className={path === `${RoutePathNames.GTBMAPPINGKEYS}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <Map fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>GTB Mapping Keys</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.GTBRECORDS} className={path === `${RoutePathNames.GTBRECORDS}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <FolderCopy fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>GTB Records</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.RECONCILIATIONRULES} className={path === `${RoutePathNames.RECONCILIATIONRULES}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <RuleSharp fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>Reconciliation Rules</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                
                               
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.REPORT_LIST} className={path === `${RoutePathNames.REPORT_LIST}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <Report fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div className='icon-text'>Reports</div>
                                        </div>
                                    </a>
                                </li>
                                <br/>
                                <li style={{ textAlign: 'center', marginBottom: '10px' }} >
                                    <a href={'/' + RoutePathNames.USERS} className={path === `${RoutePathNames.USERS}` ? 'isactive' : path === `` ? 'isactive' : path === '' ? 'isactive' : ''}>
                                        <div className='sidebar-options'>
                                            <div className='icon-card'>
                                                <Group fontSize='medium' style={{ margin: '5px', fontSize: '24px' }} />
                                            </div>

                                            <div  className='icon-text'>User &nbsp; Management</div>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>

                    </Drawer>
                )
                }
            </Box >
        </>
    )
}
export default Sidebar